import React, { useState, useEffect } from "react";
import { CuratedCollection } from "../types";
import ProductCard from "@/frontend/algolia/components/ProductCard";
import { getClosestAspectRatio } from "@/frontend/algolia/utils/aspectRatio";

interface CuratedCollectionsProps {
  title: string;
  collections: CuratedCollection[];
}

const CuratedCollections: React.FC<CuratedCollectionsProps> = ({ collections, title }) => {
  const [aspectRatio, setAspectRatio] = useState<string>("4/3");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!collections.length) {
      setIsLoading(false);
      return;
    }

    const img = new Image();
    img.onload = () => {
      const ratio = img.naturalWidth / img.naturalHeight;
      const closestRatio = getClosestAspectRatio(ratio);
      setAspectRatio(closestRatio);
      setIsLoading(false);
    };
    img.onerror = () => {
      // Fallback to default if image fails to load
      setAspectRatio("4/3");
      setIsLoading(false);
    };
    img.src = collections[0]?.imageSrc || "";
  }, [collections]);

  if (!collections.length) {
    return null;
  }

  const showOnlyTwoOnMobileTablet = "[&]:last-of-type:tw-hidden md:[&]:last-of-type:tw-block";

  return (
    <div className="tw-space-y-2">
      <h2 className="tw-text-xl">{title}</h2>

      <div className="tw-grid md:tw-grid-cols-3 tw-gap-3">
        {collections.slice(0, 3).map((collection, index) => (
          <div key={index} className={showOnlyTwoOnMobileTablet}>
            <ProductCard
              title={collection.title}
              description={""}
              imageSrc={collection.imageSrc}
              link={collection.link}
              aspectRatio={aspectRatio}
              isLoading={isLoading}
              bgColor="tw-bg-transparent"
            />  
          </div>
        ))}
      </div>
    </div>
  );
};

export default CuratedCollections;